import { Avatar, Dropdown, Layout, Space, App } from 'antd';
import Navbar from './Navbar';
import { useEffect } from 'react';
import { setUser, clearUser, getSessionInfo } from '@features/auth/authSlice'
import { subscribeAuthEvents } from '@auth/userEvents';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { SignoutRedirectArgs } from 'oidc-client-ts';
import { signoutRedirect, getUser, removeUser } from '@auth/authService';
import { useNavigate } from 'react-router-dom';

const { Header, Content } = Layout;

const AppLayout = ({ children }: { children: React.ReactNode }) => {
    const navigate= useNavigate()
    const { modal } = App.useApp()
    const dispatch = useAppDispatch();
    const user = useAppSelector(store => store.auth.user)

    useEffect(() => {
        // Load initial user on first load
        getUser().then(user => {
            if (user && !user.expired) {
                dispatch(setUser(user.profile));
            }
        });

        // Subscribe to auth events
        subscribeAuthEvents(user => {
            if (user) {
                dispatch(setUser(user?.profile));
            } else {
                dispatch(clearUser());
            }
        });
    }, [dispatch]);

    useEffect(() => {
        if (user) {
            dispatch(getSessionInfo())
        }
    }, [user, dispatch])

    const onLogout = () => {
        modal.confirm({
            title: 'Xác nhận',
            okText: 'Chắc chắn',
            okButtonProps: { danger: true },
            content: 'Bạn chắc chắn muốn đăng xuất?',
            onOk: () => {
                getUser().then(user => {
                    const params: SignoutRedirectArgs = {}
                    if (user?.id_token) {
                        params.id_token_hint = user.id_token
                    }

                    removeUser().then(() => {
                        signoutRedirect(params)
                    })
                })
            }
        })
    }

    return (
        <Layout style={{ minHeight: '100vh' }}>
            {
                user && (
                    <Header className='app-header-top'>
                        <div className="app-logo" onClick={() => navigate('/')}>
                            JAPAN SYSTEM
                        </div>
                        <Navbar />

                        <div className='account-menu-top'>
                            <Dropdown
                                placement='bottomRight'
                                menu={{
                                    items: [{
                                        key: 'logout',
                                        label: <Space><LogoutOutlined />Đăng xuất</Space>,
                                        onClick: onLogout
                                    }]
                                }}>
                                <Space>
                                    <Avatar icon={<UserOutlined />} />
                                    <span className='account-name'>{user.name}</span>
                                </Space>
                            </Dropdown>
                        </div>
                    </Header>
                )
            }
            <Content style={{ padding: 15 }}>{children}</Content>
        </Layout>
    );
};

export default AppLayout;
